import * as Yup from "yup";
import { isValidPhoneNumber } from 'react-phone-number-input';

const formValidationSchema = Yup.object().shape({
    firstName: Yup.string()
        .trim()
        .min(2, "First name must be at least 2 characters")
        .max(100, "First name is too long")
        .nullable(),
    email: Yup.string()
        .trim()
        .email("Invalid email format")
        .nullable(),
    phone: Yup.string()
        .nullable()
        .test(
            'is-valid-phone',
            'Please enter a valid phone number',
            (value) => !value || isValidPhoneNumber(value)
        ),
    country: Yup.string()
        .trim()
        .nullable(),
    semester: Yup.string()
        .matches(/^\d+$/, "Semester must be a valid integer")
        .nullable()
});
export default formValidationSchema;

